import { render } from "./ItPage.vue?vue&type=template&id=3d3da6ce"
import script from "./ItPage.vue?vue&type=script&lang=js"
export * from "./ItPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__